import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {map, Observable} from "rxjs";
import {environment} from "../../environments/environment";
import {IPluralResponse, ISingleResponse} from "../../core/shared/interface/i.response";
import {ICampaign} from "../../core/business-logic/campaign/interface/i.campaign";

@Injectable({
  providedIn: 'root'
})
export class CampaignApiService {

  public readonly endpoint: string = `https://api.car4ukraine.com/api/campaigns`;

  private readonly httpClient = inject(HttpClient);

  public seoDocuments(page: number = 1): Observable<IPluralResponse<ICampaign.DTO>> {
    return this.httpClient.get<IPluralResponse<ICampaign.DTO>>(this.endpoint, {
      headers: {
        Authorization: `Bearer ${environment.api.token.backend}`
      },
      params: {
        'populate': 'photo',
        'pagination[page]': page,
        'pagination[pageSize]': '100',
        sort: 'createdAt:desc',
      }
    });
  }

  public documents(): Observable<IPluralResponse<ICampaign.DTO>> {
    return this.httpClient.get<IPluralResponse<ICampaign.DTO>>(this.endpoint, {
      headers: {
        Authorization: `Bearer ${environment.api.token.backend}`
      },
      params: {
        'populate[0]': 'photo',
        'populate[1]': 'campaign',
        'populate[2]': 'campaigns.fundraiser',
        'filters[campaign][$null]': true,
        'filters[channel][$eq]': environment.channel,

        sort: 'createdAt:desc',
      }
    });
  }

  public document(id: string): Observable<ISingleResponse<ICampaign.DTO>> {
    return this.httpClient.get<ISingleResponse<ICampaign.DTO>>(this.endpoint + '/' + id, {
      headers: {
        Authorization: `Bearer ${environment.api.token.backend}`
      },
      params: {
        populate: '*',
      }
    });
  }

  public documentBySlug(slug: string): Observable<ISingleResponse<ICampaign.DTO>> {
    return this.httpClient.get<IPluralResponse<ICampaign.DTO>>(`${this.endpoint}`, {
      headers: {
        Authorization: `Bearer ${environment.api.token.backend}`
      },
      params: {
        'populate[0]': 'banner',
        'populate[1]': 'photo',
        'populate[2]': 'campaigns.fundraiser',
        'populate[3]': 'campaigns.fundraiser.photo',
        'populate[4]': 'fundraiser',
        'populate[5]': 'fundraiser.photo',
        'populate[6]': 'campaign',
        'populate[7]': 'campaign.campaigns',
        'filters[slug][$eq]': slug,
      }
    }).pipe(
      map(({data, meta}) => {
        return {
          data: data[0],
          meta,
        };
      })
    );
  }

}
